"use strict";
(function (global) {

  /**
   * Базовый класс фабрики объектов.
   *
   * @class WebAccess.factories.BaseFactory
   * @param {OBJECT_TYPE} contentType Тип объектов.
   * @throws ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED - заданы не все обязательные параметры.
   * @since 5.0.0.7300
   */
  var BaseFactory = BaseObject.extend({

    className: "BaseFactory",
    contentType: OBJECT_TYPE.UNKNOWN,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (contentType) {
      if (contentType < 0) {
        WA.raise("ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED", "contentType");
      }
      this.contentType = contentType;
      this._super(contentType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает объект по ИД.
     *
     * @method  WebAccess.factories.BaseFactory#getObjectByID
     * @param {number} id ИД объекта.
     * @param {MODEL} [opt_modelType] Тип возвращаемой модели данных.
     * @since 5.0.0.7300
     * @return {Deferred<Object>} Объект по ИД.
     * @see https://api.jquery.com/category/deferred-object/
     */
    getObjectByID: function (id, opt_modelType) {
      var me = this;
      opt_modelType = (!opt_modelType) ? MODEL.FULL : opt_modelType;
      var proxyCall = $.Deferred();

      var result;
      WA.SRV.call('Factories.asmx/GetObjectByID', { ObjectType: me.contentType, ID: id, ReferenceName: me.referenceName || '', Mode: opt_modelType }).done(function (model) {
        result = me._handleModel(model, opt_modelType);
        proxyCall.resolve(result);
      }).fail(function (err) {
        proxyCall.reject(err);
      });
      return proxyCall;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Исходя из типа модели возвращает соответствующий объект.
     * @private
     * @method  WebAccess.factories.BaseFactory#_handleModel
     * @since 5.0.0.7300
     * @return {Object}
     */
    _handleModel: function (model, opt_modelType) {
      var me = this;
      var result;
      if (opt_modelType == MODEL.LINK) {
        var link = new WA.Link(model.ID, this.contentType, this.referenceName || null);
        link.isNew = (!!model.IsNew);
        result = link;
      } else {
        if (me.contentType === OBJECT_TYPE.EDOCUMENT) {
          result = new DocumentModel(model);
        } else if (me.contentType === OBJECT_TYPE.REFERENCE_RECORD) {
          result = new ReferenceRecordModel(model);
        } else {
          result = new BaseObjectModel(model);
        }
      }
      return result;
    },

    // Пусть будет пока, но в справку не лезет
    objectInfo: function (id) {
      return this.getObjectByID(id, 1);
    }
  });
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.BaseFactory = BaseFactory;

})(window.WebAccess.factories);